import React from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import Text from '@/components/common/Text'
import TryFreeCta from '@/components/TryFreeCta'

import styles from './BottomCTA.module.scss'

export default function BottomCTA({ t }) {
  return (
    <section className={styles.section}>
      {/* Decorative circles - left */}
      <div className={styles.circlesLeft}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>

      {/* Decorative circles - right */}
      <div className={styles.circlesRight}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>
      <div className={styles.circlesBottom}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>

      {/* Side images */}
      <div className={styles.imageLeft}>
        <Image
          alt=""
          className={styles.desktopOnly}
          height={420}
          src="/home2/ready-left.webp"
          style={{ objectFit: 'contain' }}
          width={260}
        />
        <Image
          alt=""
          className={styles.mobileOnly}
          height={220}
          src="/home2/bottomCTA-mobile1.webp"
          style={{ objectFit: 'contain' }}
          width={140}
        />
      </div>
      <div className={styles.imageRight}>
        <Image
          alt=""
          className={styles.desktopOnly}
          height={380}
          src="/home2/ready-right.webp"
          style={{ objectFit: 'contain' }}
          width={320}
        />
        <Image
          alt=""
          className={styles.mobileOnly}
          height={280}
          src="/home2/bottomCTA-mobile2.webp"
          style={{ objectFit: 'contain' }}
          width={240}
        />
      </div>

      {/* Content */}
      <div className={styles.inner}>
        <Text.H2 className={styles.title}>{t.title}</Text.H2>
        <Text.P className={styles.subtitle}>{t.subtitle}</Text.P>
        <TryFreeCta buttonMessageId={null} className={styles.ctaBtn} size="xlTall">
          {t.cta}
          <img alt="" className={styles.ctaArrow} height={16} src="/home2/arrow-right.svg" width={16} />
        </TryFreeCta>
        <div className={styles.badges}>
          <div className={styles.badge}>
            <Image alt="" height={18} src="/home2/check-icon.svg" width={18} />
            <Text className={styles.badgeText}>{t.cancelAnytime}</Text>
          </div>
          <div className={styles.badge}>
            <Image alt="" height={18} src="/home2/sheild-icon.svg" width={18} />
            <Text className={styles.badgeText}>{t.moneyBack}</Text>
          </div>
        </div>
      </div>
    </section>
  )
}

BottomCTA.propTypes = {
  t: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    cancelAnytime: PropTypes.string.isRequired,
    moneyBack: PropTypes.string.isRequired,
  }).isRequired,
}
